import React, { useEffect, useState, useRef } from 'react';
import HomeItem from '@/pages/agency/home/components/home-item/index.tsx';
import './style.less';
import { reportSeasUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import { formatePhoneTime } from '@/pages/saleTarget/common/constants.js';
import { Icon } from '@tencent/spaui';
import actions from '@/pages/saleTarget/api';
import { currencyFormatV2 } from '@/pages/agency/utils/format.js';
import dayjs from 'dayjs';
import globalStore from '@/stores';
import { withAccount } from '@/business-components/operator/account-context';
import perms from '@/common/permissions/sale/perms';

const page1 = '首页';
const page2 = '销售数据';
const page3 = '';
const page4 = '';

const Board = (props) => {
  const {
    title,
    account: { saleStatus },
  } = props;
  const { grayPermissions = [] } = saleStatus || {};
  const contentDom = useRef();
  const [detailData, setDetailData] = useState({});

  const {
    performanceAdFeeOverviewVo = {},  // 广告费概览 月
    performanceOrderOverviewVo = {}, // 订单概览 月
    callDurationOverviewVo = {}, // 通话时长
    callNumberOverviewVo = {}, // 通话数量
    leadNumOverviewVo = {}, // 新增线索
    potentialNumOverviewVo = {}, // 新增商机
  } = detailData || {};

  const handleJumpDetail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
    console.log('open a');
    window.open('/ams/target/my');

    reportSeasUserBehaviorCgi({ data: {
      page1,
      page2,
      page3,
      page4,
      behavior: '跳转我的目标',
    } });
  };

  useEffect(() => {
    // 没有灰度 不请求
    // 没有服务商id 不是销售，不展示相关内容
    if (!globalStore?.account?.sale_agency_uid) {
      return;
    }

    if (!grayPermissions.includes(perms.GRAY_SEAS_HOME_SALE_DATA)) {
      return;
    }
    actions.myTargetOverView({
      // userId
      beginMonth: dayjs().format('YYYYMM'),
      endMonth: dayjs().format('YYYYMM'),
    }).then((res) => {
      const {
        performanceAdFeeOverviewVo, // 销售端广告费概览
        performanceOrderOverviewVo, // 销售端订单概览
        callDurationOverviewVo, // 通话时长
        callNumberOverviewVo, // 通话数量
        leadNumOverviewVo, // 新增线索
        potentialNumOverviewVo, // 新增商机
      } = res.data || {};
      setDetailData({
        performanceAdFeeOverviewVo,
        performanceOrderOverviewVo,
        callDurationOverviewVo, // 通话时长
        callNumberOverviewVo, // 通话数量
        leadNumOverviewVo, // 新增线索
        potentialNumOverviewVo, // 新增商机
      });
    });
  }, []);

  // 没有服务商id 不是销售，不展示相关内容
  if (!globalStore?.account?.sale_agency_uid) {
    return null;
  }

  // 没有灰度 返回空
  if (!grayPermissions.includes(perms.GRAY_SEAS_HOME_SALE_DATA)) {
    return null;
  }

  return (
    <HomeItem
      className="home-sale-board"
      header={(
        <>
          <div className="title">{title}</div>
          <div className="to-detail" onClick={handleJumpDetail}>
          查看详情<Icon name='right-arrow-outlined' style={{ verticalAlign: 'text-bottom' }}/>
          </div>
        </>
      )}
    >
      <div className='flex' ref={contentDom} style={{ flexWrap: 'wrap', gap: '22px', paddingTop: '10px' }}>
        <section className='mounth-data'>
          <div className='detail-title'>本月业绩</div>
          <div className='flex detail-container'>
            <div className='detail-content'>
              <p>订单数量</p>
              <div>已达成数/目标数</div>
              <section className='num-content'>
                <span>{currencyFormatV2(performanceOrderOverviewVo?.realOrderNumber || 0)}</span>
                <span>/{currencyFormatV2(performanceOrderOverviewVo?.salesTargetOrderNumber || 0)}</span>
              </section>
            </div>
            <div className='detail-content'>
              <p>广告费金额</p>
              <div>已达成数/目标数</div>
              <section className='num-content'>
                <span>{currencyFormatV2(performanceAdFeeOverviewVo?.realAdFee / 100)}</span>
                <span>/{currencyFormatV2(performanceAdFeeOverviewVo?.salesTargetAdFee / 100)}</span>
              </section>
            </div>
          </div>
        </section>
        <section className='day-data'>
          <div className='detail-title'>今日业绩</div>
          <div className='flex detail-container'>
            <div className='detail-content'>
              <p>新增线索量</p>
              <div>已达成数/目标数</div>
              <section className='num-content'>
                <span>{leadNumOverviewVo?.realNum}</span>
                <span>/{leadNumOverviewVo?.targetNum || 0}</span>
              </section>
            </div>
            <div className='detail-content'>
              <p>通话次数</p>
              <div>已达成数/目标数</div>
              <section className='num-content'>
                <span>{callNumberOverviewVo?.realNum}</span>
                <span>/{callNumberOverviewVo?.targetNum || 0}</span>
              </section>
            </div>
            <div className='detail-content'>
              <p>通话时长</p>
              <div>已达成数/目标数</div>
              <section className='num-content'>
                <span>{formatePhoneTime(callDurationOverviewVo?.realNum)}</span>
                <span>/{formatePhoneTime(callDurationOverviewVo?.targetNum)}</span>
              </section>
            </div>
            <div className='detail-content'>
              <p>新增商机</p>
              <div>已达成数/目标数</div>
              <section className='num-content'>
                <span>{potentialNumOverviewVo?.realNum}</span>
                <span>/{potentialNumOverviewVo?.targetNum || 0}</span>
              </section>
            </div>
          </div>
        </section>
      </div>
    </HomeItem>
  );
};

export default withAccount(Board);
